/**
 * ChangeKeyboardLanguageDirectiveController is a class that manages the logic for changing the keyboard language in a web application.
 * It interacts with AngularJS services and scope to handle keyboard language changes based on the current route and context.
 */
class ChangeKeyboardLanguageDirectiveController {
    /**
     * Constructor for ChangeKeyboardLanguageDirectiveController.
     * @param {Object} $scope - The AngularJS scope.
     * @param {Object} $route - The AngularJS route service.
     * @param {Object} $injector - The AngularJS injector service.
     */
    constructor($scope, $route, $injector) {
        this.$scope = $scope;
        this.$route = $route;
        this.$injector = $injector;

        this.$logger = $injector.get('LogBridgeService');
        this.BridgeRuntimeService = $injector.get('BridgeRuntimeService');

        this.$scope._logIdentifier = 'ChangeKeyboardLanguageDirectiveController';
        this.$logger.logExit(this.$scope, 'initialisation');

        this.initialize();
    }

    /**
     * Initializes the controller by setting up the available keyboard languages and the change handler.
     */
    initialize() {
        if (this.$scope.inSheet || this.$scope.inOverview) {
            if (this.inOverview() && !this.$scope.inOverview) return;
            if (this.inSheet() && !this.$scope.inSheet) return;
            if (!this.inOverview() && !this.inSheet()) return;
        }
        if (this.$scope.inOverview === false && this.$scope.inSheet === false) return;

        const _listKeyboardLanguagesAvailable = this.BridgeRuntimeService.listKeyboardLanguagesAvailable();
        this.$scope.listKeyboardLanguagesAvailable = angular.isObject(_listKeyboardLanguagesAvailable) && Object.keys(_listKeyboardLanguagesAvailable).length > 1 ? _listKeyboardLanguagesAvailable : false;

        this.$scope.onChangeKeyboardLanguage = (val) => {
            this.BridgeRuntimeService.changeKeyboardLanguage(val);
        };
    }

    /**
     * Checks if the current route is in the overview.
     * @returns {boolean} - True if the current route is in the overview, false otherwise.
     */
    inOverview() {
        return this.$route.current.params.taskUUID && this.$route.current.regexp.test("/overview/:taskUUID");
    }

    /**
     * Checks if the current route is in the sheet.
     * @returns {boolean} - True if the current route is in the sheet, false otherwise.
     */
    inSheet() {
        return this.$route.current.params.sheetUUID && this.$route.current.regexp.test("/sheet/:sheetUUID");
    }
}

export default ChangeKeyboardLanguageDirectiveController;